import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';
import { MediaType } from '../MediaType';

export const experimentalPublishPageAsBlog: ExperimentalMutations['experimentalPublishPageAsBlog'] =
	(
		_,
		{
			contentId,
			destinationType,
			destinationSpaceKey,
			sourceStatus,
			content,
			title,
			syncRev,
			ncsStepVersion,
			message,
			suppressNotifyWatchers,
			schedulePublishDate,
			restrictions,
		},
		{ network },
	) => {
		let url = `/wiki/rest/api/content/${contentId}/convert?destinationType=${destinationType}&sourceStatus=${sourceStatus}`;

		url = destinationSpaceKey ? `${url}&destinationSpaceKey=${destinationSpaceKey}` : url;

		const version: {
			number: number;
			message: string;
			syncRev?: string | null;
			minorEdit?: Boolean;
			ncsStepVersion?: string | null;
		} = {
			number: 1,
			message: message || '',
			minorEdit: suppressNotifyWatchers || false,
			syncRev: syncRev || undefined, // classic editor requires syncRev when making REST call
			ncsStepVersion: ncsStepVersion || undefined, // NCS editor requires ncsStepVersion when making REST call
		};

		const body =
			sourceStatus === 'draft'
				? {
						id: contentId,
						type: 'page',
						title,
						space: { key: destinationSpaceKey },
						schedulePublishDate,
						restrictions,
						body: {
							editor: {
								value: content,
								representation: 'atlas_doc_format',
								content: {
									id: contentId,
								},
							},
						},
						status: 'draft',
						version,
					}
				: {};

		return network
			.cfetch(url, {
				method: 'POST',
				credentials: 'include',
				headers: {
					'Content-Type': MediaType.JSON,
				},
				body: JSON.stringify(body),
			})
			.then((response) => response.json())
			.catch(async (reason) => {
				throw await reason.response.json(); // need this to get more detailed error message from BE
			});
	};
